// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/2.4.0/css/" + chunkId + "." + "d8a6de4e" + ".chunk.css";
};